enum AddressTypeEnum {
  SEND,
  PICKUP,
}
export default AddressTypeEnum;
